(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Header + mobile navigation
  const header = $('[data-mff-header]');
  const menuToggle = $('[data-mff-menu-toggle]');
  const mobileMenu = $('[data-mff-mobile-menu]');
  const syncHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 10);
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });
  const megaMenu = $('[data-mff-mega-menu]');
  menuToggle?.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') !== 'true';
    menuToggle.setAttribute('aria-expanded', String(open));
    if (innerWidth > 1050 && megaMenu) {
      megaMenu.classList.toggle('is-open', open);
      megaMenu.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('mff-mega-open', open);
      return;
    }
    mobileMenu?.classList.toggle('is-open', open);
    document.body.classList.toggle('mff-lock', open);
  });
  $$('[data-mff-mobile-menu] a').forEach(a => a.addEventListener('click', () => {
    menuToggle?.setAttribute('aria-expanded', 'false');
    mobileMenu?.classList.remove('is-open');
    document.body.classList.remove('mff-lock');
  }));

  // Cursor light
  if (matchMedia('(pointer:fine)').matches) {
    window.addEventListener('pointermove', e => {
      document.documentElement.style.setProperty('--cursor-x', `${e.clientX}px`);
      document.documentElement.style.setProperty('--cursor-y', `${e.clientY}px`);
    }, { passive: true });
  }

  // 3D product-card tilt
  if (!reduceMotion && matchMedia('(pointer:fine)').matches) {
    $$('[data-mff-tilt]').forEach(card => {
      card.addEventListener('pointermove', e => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width;
        const y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--tilt-y', `${(x - .5) * 7}deg`);
        card.style.setProperty('--tilt-x', `${(.5 - y) * 6}deg`);
        card.style.setProperty('--glow-x', `${x * 100}%`);
        card.style.setProperty('--glow-y', `${y * 100}%`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.removeProperty('--tilt-x');
        card.style.removeProperty('--tilt-y');
      });
    });
  }

  // Product gallery
  $$('[data-mff-gallery]').forEach(gallery => {
    const main = $('[data-mff-main-image]', gallery);
    $$('[data-mff-thumb]', gallery).forEach(btn => btn.addEventListener('click', () => {
      if (!main) return;
      main.src = btn.dataset.src;
      main.srcset = '';
      main.alt = btn.dataset.alt || '';
      $$('[data-mff-thumb]', gallery).forEach(x => x.classList.remove('is-active'));
      btn.classList.add('is-active');
    }));
  });

  // Product price change on variant selection
  $$('[data-mff-product-form]').forEach(formWrap => {
    const select = $('select[name="id"]', formWrap);
    const price = $('[data-mff-product-price]', formWrap.closest('[data-mff-product]') || document);
    const button = $('[data-mff-add-button]', formWrap);
    select?.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = option.disabled;
        button.textContent = option.disabled ? button.dataset.sold : button.dataset.available;
      }
    });
  });

  // Hero depth-field canvas + spatial product orbit
  $$('[data-mff-hero]').forEach(hero => {
    const canvas = $('[data-mff-depth-canvas]', hero);
    const orbit = $('[data-mff-orbit]', hero);
    const shells = $$('[data-mff-orbit-shell]', hero);
    const intensity = Number(hero.dataset.intensity || 65) / 100;
    const enabled = hero.dataset.enabled === 'true' && !reduceMotion;
    let heroVisible = true;
    let pointerX = 0, pointerY = 0, targetX = 0, targetY = 0, spin = 0;

    if ('IntersectionObserver' in window) {
      const heroObserver = new IntersectionObserver(([entry]) => {
        heroVisible = entry.isIntersecting;
      }, { rootMargin: '240px 0px' });
      heroObserver.observe(hero);
    }

    hero.addEventListener('pointermove', e => {
      const r = hero.getBoundingClientRect();
      targetX = ((e.clientX - r.left) / r.width - .5) * 2;
      targetY = ((e.clientY - r.top) / r.height - .5) * 2;
    }, { passive: true });
    hero.addEventListener('pointerleave', () => { targetX = targetY = 0; });

    if (orbit) {
      const layoutOrbit = () => {
        const mobile = innerWidth < 720;
        const radius = mobile ? Math.min(innerWidth * .42, 180) : Math.min(innerWidth * .22, 350);
        shells.forEach(shell => {
          const angle = Number(shell.dataset.angle || 0);
          shell.style.transform = `rotateY(${angle}deg) translateZ(${radius}px)`;
          const card = shell.firstElementChild;
          if (card) card.style.transform = `rotateY(${-angle - spin}deg) rotateX(${mobile ? 2 : 5}deg)`;
        });
      };
      const animateOrbit = () => {
        if (!heroVisible || document.hidden) {
          setTimeout(() => requestAnimationFrame(animateOrbit), 250);
          return;
        }
        pointerX += (targetX - pointerX) * .04;
        pointerY += (targetY - pointerY) * .04;
        if (enabled) spin = (spin + .055 * intensity) % 360;
        orbit.style.transform = `rotateX(${-6 + pointerY * 4 * intensity}deg) rotateY(${spin + pointerX * 8 * intensity}deg)`;
        const mobile = innerWidth < 720;
        const radius = mobile ? Math.min(innerWidth * .42, 180) : Math.min(innerWidth * .22, 350);
        shells.forEach(shell => {
          const angle = Number(shell.dataset.angle || 0);
          shell.style.transform = `rotateY(${angle}deg) translateZ(${radius}px)`;
          const card = shell.firstElementChild;
          if (card) card.style.transform = `rotateY(${-angle - spin - pointerX * 8 * intensity}deg) rotateX(${6 - pointerY * 4 * intensity}deg)`;
        });
        requestAnimationFrame(animateOrbit);
      };
      layoutOrbit();
      addEventListener('resize', layoutOrbit, { passive: true });
      requestAnimationFrame(animateOrbit);
    }

    if (!canvas) return;
    const ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return;
    let w = 0, h = 0, dpr = 1;
    let points = [];
    const count = Math.min(110, Math.max(42, Math.floor(innerWidth / 14)));
    const reset = p => {
      p.x = (Math.random() - .5) * w * 1.7;
      p.y = (Math.random() - .5) * h * 1.4;
      p.z = Math.random() * 1200 + 100;
      p.v = Math.random() * 1.1 + .35;
      return p;
    };
    const resize = () => {
      dpr = Math.min(devicePixelRatio || 1, 1.7);
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = Math.max(1, w * dpr); canvas.height = Math.max(1, h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      points = Array.from({ length: count }, () => reset({}));
    };
    resize();
    addEventListener('resize', resize, { passive: true });
    const draw = () => {
      if (!heroVisible || document.hidden) {
        setTimeout(() => requestAnimationFrame(draw), 250);
        return;
      }
      ctx.clearRect(0, 0, w, h);
      const focal = 460;
      points.forEach(p => {
        if (enabled) p.z -= p.v * (1 + intensity);
        if (p.z < 20) reset(p);
        const scale = focal / p.z;
        const x = w / 2 + p.x * scale + pointerX * 22;
        const y = h / 2 + p.y * scale + pointerY * 15;
        const alpha = Math.max(0, Math.min(.55, (1 - p.z / 1300) * .65));
        const r = Math.max(.35, 1.8 * scale);
        ctx.beginPath();
        ctx.fillStyle = `rgba(255,255,255,${alpha})`;
        ctx.arc(x, y, r, 0, Math.PI * 2);
        ctx.fill();
      });
      requestAnimationFrame(draw);
    };
    requestAnimationFrame(draw);
  });


  // MFF editorial signature reveals: one lightweight pass per element.
  const initEditorialSignature = (root = document) => {
    const elements = $$(
      '.mff-renewed-eyebrow, .mff-renewed-title, .mff-section-head > *, .mff-renewed-section__head > *, .mff-renewed-story__copy > *, .mff-about-editorial__gallery > header > *, .mff-product-reviews__header > *',
      root
    ).filter((element) => !element.dataset.mffEditorialReady);

    elements.forEach((element, index) => {
      element.dataset.mffEditorialReady = 'true';
      element.classList.add('mff-editorial-reveal');
      element.style.setProperty('--mff-editorial-delay', `${(index % 4) * 70}ms`);
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-mff-editorial-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, activeObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-mff-editorial-visible');
        activeObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });

    elements.forEach((element) => observer.observe(element));
  };

  initEditorialSignature();
  document.addEventListener('shopify:section:load', (event) => initEditorialSignature(event.target));


  // Premium image loading states.
  const initImageStates = (root = document) => {
    $$('img', root).forEach((image) => {
      if (image.dataset.mffImageReady) return;
      image.dataset.mffImageReady = 'true';
      const shell = image.parentElement;
      if (!shell) return;
      if (image.complete) {
        shell.classList.add('mff-image-loaded');
        return;
      }
      shell.classList.add('mff-image-loading');
      image.addEventListener('load', () => {
        shell.classList.remove('mff-image-loading');
        shell.classList.add('mff-image-loaded');
      }, { once: true });
      image.addEventListener('error', () => shell.classList.remove('mff-image-loading'), { once: true });
    });
  };

  // AJAX cart drawer.
  const drawer = $('[data-mff-cart-drawer]');
  const drawerOverlay = $('[data-mff-cart-overlay]');
  const drawerItems = $('[data-mff-cart-items]');
  const drawerTotal = $('[data-mff-cart-total]');
  const shippingCopy = $('[data-mff-shipping-copy]');
  const shippingValue = $('[data-mff-shipping-value]');
  const shippingProgress = $('[data-mff-shipping-progress]');
  const currency = window.Shopify?.currency?.active || 'EUR';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency }).format(cents / 100);
  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#039;' }[char]));

  const openDrawer = () => {
    if (!drawer) return;
    document.body.classList.add('mff-cart-opened');
    drawer.setAttribute('aria-hidden', 'false');
  };
  const closeDrawer = () => {
    document.body.classList.remove('mff-cart-opened');
    drawer?.setAttribute('aria-hidden', 'true');
  };

  const renderCart = (cart) => {
    $$('.mff-cart-count').forEach((count) => { count.textContent = cart.item_count; });
    if (!drawerItems) return;
    if (!cart.item_count) {
      drawerItems.innerHTML = '<div class="mff-cart-drawer__empty">Dein Warenkorb ist leer.</div>';
    } else {
      drawerItems.innerHTML = cart.items.map((item) => {
        const image = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=240` : '';
        return `<article class="mff-drawer-item">
          <a href="${escapeHtml(item.url)}">${image ? `<img src="${escapeHtml(image)}" width="180" height="225" loading="lazy" alt="${escapeHtml(item.product_title)}">` : ''}</a>
          <div><h3>${escapeHtml(item.product_title)}</h3><p>${escapeHtml(item.variant_title || '')}</p><p>${item.quantity} × ${money(item.final_price)}</p></div>
          <button type="button" data-mff-remove-key="${escapeHtml(item.key)}">Entfernen</button>
        </article>`;
      }).join('');
    }
    if (drawerTotal) drawerTotal.textContent = money(cart.total_price);
    const threshold = 10000;
    const remaining = Math.max(0, threshold - cart.total_price);
    if (shippingValue) shippingValue.textContent = remaining ? money(remaining) : '✓';
    if (shippingCopy) shippingCopy.textContent = remaining ? 'Kostenloser Versand ab 100 €' : 'Kostenloser Versand erreicht';
    if (shippingProgress) shippingProgress.style.setProperty('--shipping-progress', `${Math.min(100, cart.total_price / threshold * 100)}%`);
    initImageStates(drawerItems);
  };

  const refreshCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  $$('[data-mff-cart-open]').forEach((link) => link.addEventListener('click', async (event) => {
    event.preventDefault();
    await refreshCart();
    openDrawer();
  }));
  $('[data-mff-cart-close]')?.addEventListener('click', closeDrawer);
  drawerOverlay?.addEventListener('click', closeDrawer);
  addEventListener('keydown', (event) => { if (event.key === 'Escape') { closeDrawer(); megaMenu?.classList.remove('is-open'); } });

  drawerItems?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mff-remove-key]');
    if (!button) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: button.dataset.mffRemoveKey, quantity: 0 }) });
    await refreshCart();
  });

  $$('[data-mff-product-form] form').forEach((form) => form.addEventListener('submit', async (event) => {
    if (event.submitter?.name === 'checkout') return;
    event.preventDefault();
    const button = $('[data-mff-add-button]', form);
    if (button) button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Cart add failed');
      await refreshCart();
      openDrawer();
    } catch (error) {
      form.submit();
    } finally {
      if (button) button.disabled = false;
    }
  }));

  initImageStates();
  document.addEventListener('shopify:section:load', (event) => initImageStates(event.target));
})();
